<template>
  <q-form ref="formCallOs" autofocus>
    <div class="col-12 flex row q-mt-lg">
      <label class="label-title-content" for="conclusion_time">Solicitar Análise</label>
      <q-input id="conclusion_time" bg-color="white" placeholder="motivo..." type="textarea" class="col-12 q-mt-sm"
        color="red-9" dense outlined :rules="[val => (val.length != '') || 'Campo Obrigatório']" lazy-rules 
        v-model="requestData.reasonCalled"
        />
      <div class="col-12 flex row justify-end">
        <q-btn unelevated rounded no-caps color="red-9" size="md" label="Abrir chamado"
        @click="verifyForm()" />
      </div>
    </div>
  </q-form>
</template>

<script setup>
import { useQuasar } from "quasar";
import { ref, reactive, onMounted } from "vue";

let props = defineProps({
  serviceOsId:Number,
  observation: String,
});
let emits = defineEmits(["openOsCall"]);

const $q = useQuasar();

let formCallOs = ref(null);
let requestData = reactive({
  serviceId:  props.serviceOsId,
  reasonCalled: "",
  descricao_error: "",
  codeStatus: 0
});


onMounted(() => {
  
});

async function verifyForm() {
  if(await formCallOs.value.validate()){
    emits("openOsCall", requestData)
  }
}

</script>

<style scoped>
.label-title-content{
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>